<template>
    <users-current @created="setPersona">
        <residencies-current slot-scope="{ data: { personas: { data: personas } } }">
            <residencies-accept-store
                slot-scope="{ data: residency }"
                :uuid="residency.uuid"
                :include="[
                    'occupant(include:tenant)',
                    'tenancy'
                ]"
                @success="onSuccess"
            >
                <base-form
                    slot-scope="{
                        sid,
                        error,
                        is_loading: is_saving,
                        store
                    }"
                    @submit="store(prepareForStore(form))"
                >
                    <div class="px-4 pt-6 border-b sm:px-6">
                        <with-variables :variables="{ residency }">
                            <p
                                slot-scope="{ residency: { tenancy: { property: { address } } } }"
                                class="mb-6"
                            >
                                Just to confirm, you're about to accept an invite to manage your tenancy at
                                <strong>{{ address.name }}</strong> on Rentora.
                            </p>
                        </with-variables>

                        <validator-alert :sid="sid" />

                        <error-modal
                            v-if="error && $error.is(error, { exclude: [400, 422] })"
                            :error="error"
                        />

                        <template v-if="is_new_tenant">
                            <form-item
                                :sid="sid"
                                :is-required="true"
                                name="first_name"
                            >
                                <template slot="label">First name</template>

                                <input-text
                                    v-model="form.first_name"
                                    :sid="sid"
                                    :autofocus="true"
                                    :disabled="is_saving"
                                    name="first_name"
                                />
                            </form-item>

                            <form-item
                                :sid="sid"
                                :is-required="true"
                                name="last_name"
                            >
                                <template slot="label">Last name</template>

                                <input-text
                                    v-model="form.last_name"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    name="last_name"
                                />
                            </form-item>
                        </template>

                        <template v-else>
                            <form-item
                                :sid="sid"
                                :is-required="true"
                                name="profile"
                            >
                                <template slot="label">Profile</template>

                                <input-select
                                    v-model="form.tenant"
                                    :options="tenantOptions(personas)"
                                    name="tenant"
                                    placeholder="Select a tenant profile..."
                                />
                            </form-item>
                        </template>
                    </div>

                    <div class="px-4 py-3 text-right rounded-b bg-grey-bg sm:px-6">
                        <base-button
                            :is-loading="is_saving"
                            class="w-full btn-blue"
                        >
                            Join Tenancy
                        </base-button>
                    </div>
                </base-form>
            </residencies-accept-store>
        </residencies-current>
    </users-current>
</template>

<script>
    import _ from 'lodash'
    import ResidenciesAcceptStore from '../../../components/residencies-accept-store'
    import ResidenciesCurrent from '../../../components/residencies-current'
    import UsersCurrent from '../../../components/users-current'

    export default {
        components: {
            ResidenciesAcceptStore,
            ResidenciesCurrent,
            UsersCurrent
        },
        data () {
            return {
                is_new_tenant: true,
                form: {
                    token: this.$route.params.token,
                    tenant: null,
                    first_name: '',
                    last_name: ''
                }
            }
        },
        methods: {
            newTenant () {
                this.is_new_tenant = true

                this.form.tenant = null
            },
            tenantOptions (personas) {
                return _.chain(personas)
                    .filter(persona => {
                        return persona.object === 'tenant'
                    })
                    .map(persona => {
                        return {
                            label: persona.name,
                            value: {
                                object: persona.object,
                                uuid: persona.uuid
                            }
                        }
                    })
                    .value()
            },
            setPersona ({ data: { personas: { data: personas } } }) {
                const options = this.tenantOptions(personas)

                if (options.length > 0) {
                    this.is_new_tenant = false
                    this.form.tenant = options[0].value
                }
            },
            prepareForStore (form) {
                return _.chain(form)
                    .cloneDeep()
                    .omit(
                        this.is_new_tenant
                            ? ['tenant']
                            : ['first_name', 'last_name']
                    )
                    .value()
            },
            onSuccess ({ data: { tenancy, occupant: { tenant } } }) {
                if (this.is_new_tenant) {
                    this.$track(
                        'auth.tenants.create',
                        'form-submission',
                        'A user has created a tenant persona'
                    )
                }

                this.$track(
                    'residencies.accept.store',
                    'form-submission',
                    'A tenant has accepted a residency'
                )

                setTimeout(() => {
                    window.location = this.$laroute.route('dashboard.tenants.tenancies.show', {
                        tenancy: tenancy.uuid,
                        tenant: tenant.uuid,
                        welcome: '✓'
                    })
                }, 0)
            }
        }
    }
</script>
